import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import myMSALObj, { handleLogout } from "./authentication";

const SessionTimeOut = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const timeoutIdRef = useRef(null);
  const startTimeRef = useRef(null);
  const logoutTimerIdRef = useRef(null);
  const timeoutDuration = 3000000; 
  const logoutTimeoutDuration = 600000; 

  const showModal = () => {
    const accounts = myMSALObj.getAllAccounts();
    if (accounts?.length > 0) {
      setIsModalVisible(true);
      logoutTimerIdRef.current = setTimeout(logout, logoutTimeoutDuration);
    }
  };

  const hideModal = () => {
    setIsModalVisible(false);
    clearTimeout(logoutTimerIdRef.current);
  };
  const resetTimeout = () => {
    clearTimeout(timeoutIdRef.current);
    startTimeRef.current = Date.now();
    timeoutIdRef.current = setTimeout(showModal, timeoutDuration);
  };

  const keepLoggedIn = () => {
    hideModal();
    resetTimeout();
  };

  const logout = () => {
    handleLogout();
    hideModal();
    console.log('Logout Success!')
  };

  useEffect(() => {
    const handleActivity = () => {
      if (!isModalVisible) {
        resetTimeout();
      }
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('load', handleActivity);

    resetTimeout();

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('load', handleActivity);
      clearTimeout(timeoutIdRef.current);
    };
  }, [isModalVisible]);

  return (
    <>
      {isModalVisible && (
        <Modal
          isOpen={isModalVisible}
          toggle={hideModal}
          className="timeout-modal"
        >
          <ModalHeader toggle={hideModal}>Session Timeout</ModalHeader>
          <ModalBody>
            Your session is about to expire due to inactivity.
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={keepLoggedIn}>Stay Logged In</Button>
            <Button color="danger" onClick={logout}>Log Out</Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default SessionTimeOut;
